import axios from "axios";
import { servicePath } from "../../utility/data";


// export const enableTwoFA = async (accessToken) => {
//   try {
//     const response = await axios.post(
//       `${servicePath}/users/enabl-2fa`,
//       {},
//       {
//         headers: {
//           'Accept': 'application/json',
//           'Authorization': `Bearer ${accessToken}`,
//         },
//       }
//     );
    
//     return response; // Success response
//   } catch (error) {
//     // If there's an error, log the error details
//     const errorMessage = error.response?.data || 'An error occurred'; // Get the error response if it exists
//     console.error(errorMessage, "22");
    
//     // Throw the error with the message to be caught in the calling function
//     throw new Error(errorMessage);
//   }
// };

export const enableTwoFA = (accessToken) => {
  const headers = {
      'Authorization': `Bearer ${accessToken}`
  }

  return axios
      .post(`${servicePath}/users/enabl-2fa`, {}, { headers })
      .then((res) => {
          return res;
      })
      .catch((error) => { 
          return error.response;
      });
}

  
  
  export const verifyTwoFA = async (code, accessToken) => {
    const payload = {
      code
    };
  
    try {
      const response = await axios.post(`${servicePath}/users/verify-2fa`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error during user registration:', error);
      throw new Error(error.response ? error.response.data.message : 'User registration failed');
    }
  };
  
  
  
  